import React from 'react';
import { services, faqServices } from '../data/mock';
import { Pill, Heart, Stethoscope, Activity, UserRoundCheck, Truck, Building, Package } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const iconMap = {
  pill: Pill,
  heart: Heart,
  stethoscope: Stethoscope,
  activity: Activity,
  'user-round-check': UserRoundCheck,
  truck: Truck,
  building: Building,
  package: Package
};

const Services = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Everything You Need, Seamlessly
            </h1>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Branded & generic medicines, diagnostics tie-ups, OPD desk, home delivery, and corporate supply — all under one roof.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px'
          }}>
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div key={service.id} className="hover-lift" style={{
                  padding: '32px',
                  background: 'var(--bg-primary)',
                  borderRadius: '0px'
                }}>
                  {IconComponent && (
                    <IconComponent size={32} style={{
                      color: service.id % 2 === 0 ? 'var(--brand-green)' : 'var(--brand-blue)',
                      marginBottom: '16px'
                    }} />
                  )}
                  <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                    {service.title}
                  </h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {service.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Why Choose Our Services
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            {[
              { title: 'Availability', description: 'Over 35,000 SKUs in stock with rare and specialty medicines readily available.' },
              { title: 'Assured Savings', description: 'Flat 20% discount on all medicines including insulins and chronic care medications.' },
              { title: 'Professional Guidance', description: 'Licensed pharmacists provide expert consultation and medication counseling.' },
              { title: 'Speed', description: 'Quick dispensing, home delivery within hours, and digital prescription management.' },
              { title: 'Secure Transactions', description: 'Digital receipts, prescription privacy, and compliant record-keeping.' }
            ].map((item, index) => (
              <div key={index} style={{
                textAlign: 'center',
                padding: '24px'
              }}>
                <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                  {item.title}
                </h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Diagnostic Partners */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '24px', textAlign: 'center' }}>
            Trusted Diagnostic Partners
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '48px',
            textAlign: 'center',
            maxWidth: '700px',
            margin: '0 auto 48px'
          }}>
            Sample collection and comprehensive lab testing through India's leading diagnostic providers.
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '60px',
            flexWrap: 'wrap'
          }}>
            {['Dr. Lal Path', 'Metropolis', 'Sterling Accuris'].map((partner, index) => (
              <div key={index} className="heading-3" style={{
                color: 'var(--text-secondary)',
                padding: '24px 32px',
                border: '1px solid var(--border-light)',
                borderRadius: '0px'
              }}>
                {partner}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Frequently Asked Questions
          </h2>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <Accordion type="single" collapsible>
              {faqServices.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="body-regular" style={{ textAlign: 'left' }}>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;